import { Row, Col, Tooltip } from 'antd';
import React from 'react';
import GridButton from './GridButton';
import { motion } from 'framer-motion';
import Animations from '../animations/Animations';

export default function GridAddButton({ onClick = () => { }, tooltip = "" }) {
    return (


        <GridButton showDotMenu={false} dashed={false} onClick={onClick} tooltip={tooltip}>
            {(isHovering) => {
                const animname = isHovering ? "iconblue" : "icongray"
                return <div style={{ width: "100%", height: "100%", overflow: "hidden" }}>
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 153 154" >
                        <g id="add_icon" transform="translate(-253 -173)">
                            <rect id="Rectangle_394" data-name="Rectangle 394" transform="translate(253 173)" fill="#fff" />
                            <motion.path animate={animname} variants={Animations.GRID_BUTTON_ADD} width="154" height="154" viewBox="0 0 153 154" id="Path_49" data-name="Path 49" d="M38.6-45.4H9.2v-17H38.6V-91.6H56v29.2H85.4v17H56v28.2H38.6Z" transform="translate(283.8 304.6)" fill="#f2f2f2" />
                        </g>
                    </svg>
                </div>
            }}
        </GridButton >
    )
}